import React, { useEffect, useState } from 'react';
import { subscribeToSiteSettings, INITIAL_WEBSITE_DATA } from '../lib/firestoreContent';

function MissionHeader() {
  const [mission, setMission] = useState(INITIAL_WEBSITE_DATA.settings.missionText);

  useEffect(() => {
    const unsubscribe = subscribeToSiteSettings((settings) => {
      if (settings?.missionText) {
        setMission(settings.missionText);
      }
    });
    return () => unsubscribe && unsubscribe();
  }, []);

  return (
    <div className='pt-36 m-5'>
      <h1
        style={{
          fontFamily: "'Clash Display', sans-serif",
        }}
        className='text-center text-[50px] md:text-[50px] m-7 font-bold text-dark'
      >
        Mission
      </h1>
      <div className='m-auto md:w-2/3 pb-[50px]'>
        <p
          style={{
            fontFamily: "'Montserrat', sans-serif",
          }}
          className='text-center text-dark leading-relaxed text-[17px] md:text-[19px]'
        >
          {mission}
        </p>
      </div>
    </div>
  );
}

export default MissionHeader;
